var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('schedule-calendar',{attrs:{"profile":_vm.profile}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex schedule-btns"},[_c('h3',[_vm._v(" Our Calendar")])])
}]

export { render, staticRenderFns }